export const _PENDING = '_PENDING';
export const _SUCCESS = '_SUCCESS';
export const _FAILURE = '_FAILURE';
